var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-8" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    tooltip:
                      _vm.modelValue.nombre_item !== ""
                        ? _vm.modelValue.nombre_item
                        : "Seleccione...",
                    readonly: "",
                    id: "item",
                    placeholder: "Producto o servicio"
                  },
                  model: {
                    value: _vm.modelValue.nombre_item,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "nombre_item", $$v)
                    },
                    expression: "modelValue.nombre_item"
                  }
                },
                [
                  _c("span", [_vm._v("Ítem")]),
                  _vm._v(" "),
                  _vm.errores.id_item
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.id_item[0]))])]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.buscarItems }
                },
                [_c("i", { staticClass: "fa fa-search" })]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    readonly: !_vm.precioEditable,
                    vMoney: "",
                    format: _vm.moneyPersonalizado,
                    placeholder: "$ #,###.##",
                    id: "precio"
                  },
                  model: {
                    value: _vm.modelValue.precio,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "precio", $$v)
                    },
                    expression: "modelValue.precio"
                  }
                },
                [
                  _c("span", [_vm._v("Precio")]),
                  _vm._v(" "),
                  _vm.errores.precio
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.precio[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.porcentaje,
                    placeholder: "###.## %",
                    id: "porcentaje_iva",
                    readonly: ""
                  },
                  model: {
                    value: _vm.modelValue.porcentaje_iva,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "porcentaje_iva", $$v)
                    },
                    expression: "modelValue.porcentaje_iva"
                  }
                },
                [_c("span", [_vm._v("% IVA")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money,
                    readonly: "",
                    placeholder: "$ #,###.##",
                    id: "iva",
                    value: _vm.iva
                  }
                },
                [_c("span", [_vm._v("IVA")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      vMoney: "",
                      format: _vm.decimalPersonalizado,
                      placeholder: "#,###.##",
                      id: "cantidad"
                    },
                    model: {
                      value: _vm.modelValue.cantidad,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "cantidad", $$v)
                      },
                      expression: "modelValue.cantidad"
                    }
                  },
                  [
                    _c("span", [_vm._v("Cantidad")]),
                    _vm._v(" "),
                    _vm.errores.cantidad
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.cantidad[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.porcentaje,
                    placeholder: "% ###.##",
                    id: "porcentaje_descuento"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.calcularDescuentoTotal.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.modelValue.porcentaje_descuento,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "porcentaje_descuento", $$v)
                    },
                    expression: "modelValue.porcentaje_descuento"
                  }
                },
                [_c("span", [_vm._v("% Descuento")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money,
                    placeholder: "$ #,###.##",
                    id: "total_descuento"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.calcularPorcentajeDescuento.apply(
                        null,
                        arguments
                      )
                    }
                  },
                  model: {
                    value: _vm.modelValue.total_descuento,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "total_descuento", $$v)
                    },
                    expression: "modelValue.total_descuento"
                  }
                },
                [_c("span", [_vm._v("Total de descuento")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.irbpnr,
                    expression: "modelValue.irbpnr"
                  }
                ],
                attrs: { type: "checkbox", disabled: "" },
                domProps: {
                  checked: Array.isArray(_vm.modelValue.irbpnr)
                    ? _vm._i(_vm.modelValue.irbpnr, null) > -1
                    : _vm.modelValue.irbpnr
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.modelValue.irbpnr,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.modelValue, "irbpnr", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.modelValue,
                            "irbpnr",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.modelValue, "irbpnr", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("IRBPNR")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money,
                    readonly: "",
                    placeholder: "$ #,###.##",
                    id: "ice",
                    value: _vm.ice
                  }
                },
                [_c("span", [_vm._v("ICE")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    readonly: "",
                    vMoney: "",
                    format: _vm.money,
                    placeholder: "$ #,###.##",
                    id: "totalIrbpnr",
                    value: _vm.irbpnr
                  }
                },
                [_c("span", [_vm._v("Total IRBPNR")])]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    readonly: "",
                    vMoney: "",
                    format: _vm.money,
                    placeholder: "$ #,###.##",
                    id: "total",
                    value: _vm.total
                  }
                },
                [
                  _c("span", [_vm._v("Total")]),
                  _vm._v(" "),
                  _vm.errores.total
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.total[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c("label", { attrs: { for: "mostrarDetalle" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.mostrar_detalle,
                    expression: "modelValue.mostrar_detalle"
                  }
                ],
                attrs: { type: "checkbox", id: "mostrarDetalle" },
                domProps: {
                  checked: Array.isArray(_vm.modelValue.mostrar_detalle)
                    ? _vm._i(_vm.modelValue.mostrar_detalle, null) > -1
                    : _vm.modelValue.mostrar_detalle
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.modelValue.mostrar_detalle,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.modelValue,
                            "mostrar_detalle",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.modelValue,
                            "mostrar_detalle",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.modelValue, "mostrar_detalle", $$c)
                    }
                  }
                }
              }),
              _c("span", [_vm._v("Mostrar detalle")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-8" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "textarea-field",
                {
                  attrs: { placeholder: "Agregue una nota", id: "detalle" },
                  model: {
                    value: _vm.modelValue.detalle,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "detalle", $$v)
                    },
                    expression: "modelValue.detalle"
                  }
                },
                [_c("span", [_vm._v("Detalle")])]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancelar")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _c("span", [_vm._v("Cancelar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.aceptarItem }
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _c("span", [_vm._v("Aceptar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { height: "auto", width: "70%", scrollable: "", name: "items" }
        },
        [
          _c("lista-item", {
            attrs: {
              tipo: _vm.tipo,
              searchButton: false,
              filterStatus: false,
              createButton: true
            },
            on: { selected: _vm.seleccionarItem }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Producto o servicio")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42ba6d68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ba6d68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemComprobante.vue
// module id = 375
// module chunks = 0